export default function processLargeArrayAsync<T = unknown[]>(
  array: T[],
  processFn: (item: T, index: number, arr: T[]) => void,
  options: { maxTimePerChunk?: number; context?: object; timeoutDuration?: number } = {}
): Promise<void> {
  return new Promise((resolve) => {
    const { maxTimePerChunk = 20, context = {}, timeoutDuration = 1 } = options;
    let index = 0;

    function doChunk() {
      const startTime = Date.now();
      while (index < array.length && Date.now() - startTime <= maxTimePerChunk) {
        processFn.call(context, array[index], index, array);
        index += 1;
      }
      if (index < array.length) {
        setTimeout(doChunk, timeoutDuration);
      } else {
        resolve();
      }
    }

    doChunk();
  });
}
